
export enum Owner { System = 1, User = 2 };
